import { createSlice, createSelector } from '@reduxjs/toolkit';
import { getTwoStepTrackingComponentState } from '../../../tracking/constants.js';
export const WRAPPER_TYPES = {
    MODAL: 'modal',
    STEP_MODAL: 'stepModal',
    INLINE_FORM: 'inlineForm',
    PAGE: 'page',
};
export const initialWrapperContextState = {
    activeWrapper: null,
    activeView: null,
    isFullscreen: false,
};
export const wrapperContextSlice = createSlice({
    name: 'wrapperContext',
    initialState: initialWrapperContextState,
    reducers: {
        setActiveWrapper: (state, action) => {
            state.activeWrapper = action.payload;
        },
        clearActiveWrapper: (state) => {
            state.activeWrapper = null;
        },
        setActiveView: (state, action) => {
            state.activeView = action.payload;
        },
        clearActiveView: (state) => {
            state.activeView = null;
        },
        setIsFullscreen: (state, action) => {
            state.isFullscreen = action.payload;
        },
        setWrapperAndView: (state, action) => {
            state.activeWrapper = action.payload.wrapper;
            state.activeView = action.payload.view;
            state.isFullscreen = action.payload.isFullscreen;
        },
        clearAll: (state) => {
            state.activeWrapper = null;
            state.activeView = null;
            state.isFullscreen = false;
        },
    },
});
export const { setActiveWrapper, clearActiveWrapper, setActiveView, clearActiveView, setIsFullscreen, setWrapperAndView, clearAll, } = wrapperContextSlice.actions;
const wrapperContextState = (state) => state.core.wrapperContext;
export const activeWrapperSelector = createSelector(wrapperContextState, (state) => state.activeWrapper);
export const activeViewSelector = createSelector(wrapperContextState, (state) => state.activeView);
export const isViewActiveSelector = (viewType) => createSelector(wrapperContextState, (state) => state.activeView === viewType);
export const isWrapperActiveSelector = (wrapperType) => createSelector(wrapperContextState, (state) => state.activeWrapper === wrapperType);
export const isFullscreenSelector = createSelector(wrapperContextState, (state) => state.isFullscreen);
/**
 * Selector for tracking component state in two-step flow
 * Replacement for trackingTwoStepLoginRegistrationStateSelector
 * to be moved to tracking folder
 */
export const twoStepTrackingComponentStateSelector = createSelector([
    activeViewSelector,
    (state) => state.core.authSuccess.lastLoginMethod,
], (activeView, lastLoginMethod) => getTwoStepTrackingComponentState(activeView, lastLoginMethod));
export default wrapperContextSlice.reducer;
//# sourceMappingURL=wrapperContextSlice.js.map